import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  constructor(private httpClient: HttpClient) { }

  refreshEnterpriseCache(): Observable<any> {
    return this.httpClient.post(environment.baseUrl + '/cache/clear', null, { responseType: 'text'});
  }

  refreshClaimsCache(): Observable<any> {
    return this.httpClient.post(environment.baseClmUrl + '/cache/clear', null, { responseType: 'text'});
  }

  refreshWorkflowCache(): Observable<any> {
    return this.httpClient.post(environment.baseWeUrl + '/cache/clear', null, { responseType: 'text'});
  }
}
